/**
 * Price range filter (dual-thumb) em vanilla JS.
 * Substitui o uso de jQuery UI slider (255KB) por <input type=range> HTML5 nativo.
 * Sincroniza com inputs de texto formato BR (8.660,00).
 */
(function () {
  'use strict';

  function parsePriceBR(value) {
    if (!value) return 0;
    return parseFloat(String(value).replace(/\./g, '').replace(',', '.')) || 0;
  }

  function initPriceSlider(slider) {
    if (!slider || slider.dataset.initialized === '1') return;
    slider.dataset.initialized = '1';

    var minInput = document.querySelector('input[name="filter.v.price.gte"]');
    var maxInput = document.querySelector('input[name="filter.v.price.lte"]');
    var minThumb = slider.querySelector('.price-range-slider__input--min');
    var maxThumb = slider.querySelector('.price-range-slider__input--max');
    var fill = slider.querySelector('.price-range-slider__fill');

    if (!minInput || !maxInput || !minThumb || !maxThumb) return;

    var MIN = parseInt(minThumb.min, 10);
    var MAX = parseInt(minThumb.max, 10);
    var STEP = parseInt(minThumb.step, 10) || 10;

    function updateFill() {
      var minVal = parseInt(minThumb.value, 10);
      var maxVal = parseInt(maxThumb.value, 10);
      var range = MAX - MIN;
      if (range <= 0) return;
      var left = ((minVal - MIN) / range) * 100;
      var right = 100 - ((maxVal - MIN) / range) * 100;
      if (fill) {
        fill.style.left = left + '%';
        fill.style.right = right + '%';
      }
    }

    // Init: ler do input text se ja preenchido
    var initialMin = parsePriceBR(minInput.value) || MIN;
    var initialMax = parsePriceBR(maxInput.value) || MAX;
    minThumb.value = Math.min(initialMin, initialMax);
    maxThumb.value = Math.max(initialMin, initialMax);
    updateFill();

    minThumb.addEventListener('input', function () {
      var minVal = parseInt(minThumb.value, 10);
      var maxVal = parseInt(maxThumb.value, 10);
      if (minVal >= maxVal) {
        minVal = maxVal - STEP;
        minThumb.value = minVal;
      }
      minInput.value = minVal;
      updateFill();
    });

    maxThumb.addEventListener('input', function () {
      var minVal = parseInt(minThumb.value, 10);
      var maxVal = parseInt(maxThumb.value, 10);
      if (maxVal <= minVal) {
        maxVal = minVal + STEP;
        maxThumb.value = maxVal;
      }
      maxInput.value = maxVal;
      updateFill();
    });

    minInput.addEventListener('change', function () {
      var val = parsePriceBR(minInput.value) || MIN;
      var maxVal = parseInt(maxThumb.value, 10);
      if (val >= maxVal) val = maxVal - STEP;
      if (val < MIN) val = MIN;
      minThumb.value = val;
      updateFill();
    });

    maxInput.addEventListener('change', function () {
      var val = parsePriceBR(maxInput.value) || MAX;
      var minVal = parseInt(minThumb.value, 10);
      if (val <= minVal) val = minVal + STEP;
      if (val > MAX) val = MAX;
      maxThumb.value = val;
      updateFill();
    });
  }

  function init() {
    var sliders = document.querySelectorAll('#price-slider, .price-range-slider');
    sliders.forEach(initPriceSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
